import React from 'react';
import PropTypes from 'prop-types';
import QuantityInput from '../QuantityInput/QuantityInput';
import { SaveToNewPartsList, SaveToExistingPartsList, GetPartsList } from '../../../../shared/services';
import PartsListAdded from './PartsListAdded';

const maxPartsNameLength = 30;

export default class PartsListModal extends React.Component {
  static preventDefaultAction(event) {
    event.preventDefault();
  }

  constructor(props) {
    super(props);
    this.state = {
      partsList: [],
      hasList: false,
      quantity: this.props.initialQuantity,
      createNewPartsList: true,
      isQuantityValid: true,
      partsListName: '',
      isPartsListNameValid: false,
      isPartsListSelectValid: false,
      addedQuantity: null,
      successMessage: null,
      errorMessage: null,
      partsListDetailsUrl: null,
    };

    this.handleExistingListChange = this.handleExistingListChange.bind(this);
    this.handleNewListChange = this.handleNewListChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.handlePartsListNameChange = this.handlePartsListNameChange.bind(this);
    this.handlePartsListSelectChange = this.handlePartsListSelectChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    GetPartsList().then(({ partsLists }) => {
      this.setState({
        partsList: partsLists,
        hasList: partsLists && partsLists.length > 0,
        createNewPartsList: !(partsLists && partsLists.length > 0),
      });
    });
  }

  setSaveSuccessful(partsListResponse) {
    this.setState({
      addedQuantity: partsListResponse.quantity,
      successMessage: partsListResponse.successMessage,
      errorMessage: partsListResponse.errorMessage,
      partsListDetailsUrl: this.props.contextPath + partsListResponse.partsListDetailsUrl,
    });
  }

  handleExistingListChange() {
    this.setState({
      createNewPartsList: false,
      isPartsListNameValid: false,
      partsListName: '',
    });
  }

  handleNewListChange() {
    this.setState({
      createNewPartsList: true,
      isPartsListSelectValid: false,
      partsListName: '',
    });
  }

  handleQuantityChange(quantity) {
    this.setState({
      quantity,
      isQuantityValid: quantity !== '',
    });
  }

  handlePartsListNameChange(e) {
    if (e.target.value.length > maxPartsNameLength) return;
    this.setState({
      partsListName: e.target.value,
      isPartsListNameValid: e.target.value !== '',
    });
  }

  handlePartsListSelectChange(e) {
    this.setState({
      partsListName: e.target.value,
      isPartsListSelectValid: e.target.value !== '',
    });
  }

  isSaveButtonEnabled() {
    return (this.state.isQuantityValid && this.state.isPartsListSelectValid && !this.state.createNewPartsList) ||
      (this.state.isQuantityValid && this.state.isPartsListNameValid && this.state.createNewPartsList);
  }

  handleSave() {
    if (this.state.createNewPartsList) {
      SaveToNewPartsList(this.state.partsListName, this.props.productNumber, this.state.quantity).then(partsListResponse => {
        this.setSaveSuccessful(partsListResponse);
      });
    } else {
      SaveToExistingPartsList(this.state.partsListName, this.props.productNumber, this.state.quantity).then(partsListResponse => {
        this.setSaveSuccessful(partsListResponse);
      });
    }
  }

  render() {
    return (
      !this.state.successMessage ?
        <div className="parts-list" id="add-to-parts-list">
          <div className="parts-title">{this.props.labels.partsListTitle}</div>
          <div className="product table">
            <QuantityInput
              className="product-quantity table-cell"
              value={this.state.quantity}
              maximumQuantity={this.props.maximumQuantity}
              onChangeHandler={this.handleQuantityChange}
            />
            <div className="product-details table-cell">
              <div>{this.props.name}</div>
              <div className="rsStockNumberDiv">
                <span>{this.props.stockNumber}</span>
              </div>
              <div className="mpnNumberDiv">
                <span>{this.props.manufacturerPartNumber}</span>
              </div>
            </div>
          </div>
          <hr />
          {this.state.hasList &&
          <div className={'selector'}>
            <label htmlFor="existing-list">
              <input
                className="option-rd"
                type="radio"
                name="existing-new"
                id="existing-list"
                onChange={this.handleExistingListChange}
                defaultChecked={this.state.hasList}
              />
              <span className="option-lb">{this.props.labels.addToExistingPartsList}</span>
            </label>
            <label htmlFor="new-list">
              <input
                className="option-rd"
                type="radio"
                name="existing-new"
                onChange={this.handleNewListChange}
                id="new-list"
                defaultChecked={!this.state.hasList}
              />
              <span className="option-lb">{this.props.labels.saveToNewPartsList}</span>
            </label>
          </div>
          }
          {!this.state.createNewPartsList ?
            <div className={'existing-new existing-list'} id="existing-list-form">
              <div className="textTitle">{this.props.labels.saveToExistingPartsListTitle}</div>
              <select className="partsListName" name="partsListName" onChange={this.handlePartsListSelectChange}>
                <option defaultValue="" value="">{this.props.labels.pleaseSelect}</option>
                {this.state.partsList.map(part => (
                  <option className="parts-list-item" value={part.name} key={part.id}>{part.name}</option>
                ))}
              </select>
            </div>
            :
            <div className={'existing-new new-list'} id="new-list-form">
              <div className="textTitle">{this.props.labels.saveToNewPartsListTitle}</div>
              {this.state.errorMessage && <div className="error-message hidden" id="parts-list-name-error">{this.state.errorMessage}</div>}
              <div className="">{this.props.labels.newPartsListName}</div>
              <input
                className="partsListName"
                name="partsListName"
                value={this.state.partsListName}
                onChange={this.handlePartsListNameChange}
                onPaste={event => PartsListModal.preventDefaultAction(event)}
                onDrop={event => PartsListModal.preventDefaultAction(event)}
              />
            </div>
          }
          <hr />
          <div className="buttons">
            <button className="btn btn-default" onClick={this.props.closeModal}>{this.props.labels.cancel}</button>
          &nbsp;
            <button
              className="btn btn-primary btn-save"
              disabled={!(this.isSaveButtonEnabled())}
              onClick={this.handleSave}
            >
              {this.props.labels.saveToPartsList}
            </button>
          </div>
        </div> : <PartsListAdded
          name={this.props.name}
          manufacturerPartNumber={this.props.manufacturerPartNumber}
          stockNumber={this.props.stockNumber}
          labels={this.props.labels}
          successMessage={this.state.successMessage}
          adddedQuantity={this.state.addedQuantity}
          closeModal={this.props.closeModal}
          partsListDetailsUrl={this.state.partsListDetailsUrl}
        />
    );
  }
}

PartsListModal.propTypes = {
  contextPath: PropTypes.string,
  name: PropTypes.string,
  stockNumber: PropTypes.string,
  initialQuantity: PropTypes.number,
  maximumQuantity: PropTypes.number,
  manufacturerPartNumber: PropTypes.string,
  productNumber: PropTypes.string,
  labels: PropTypes.shape({
    partsListTitle: PropTypes.string,
    addToExistingPartsList: PropTypes.string,
    saveToNewPartsList: PropTypes.string,
    saveToExistingPartsListTitle: PropTypes.string,
    pleaseSelect: PropTypes.string,
    saveToNewPartsListTitle: PropTypes.string,
    newPartsListName: PropTypes.string,
    cancel: PropTypes.string,
    saveToPartsList: PropTypes.string,
  }),
  closeModal: PropTypes.func,
};

PartsListModal.defaultProps = {
  contextPath: null,
  name: '',
  stockNumber: '',
  initialQuantity: 0,
  maximumQuantity: 9,
  manufacturerPartNumber: '',
  productNumber: '',
  labels: {},
  closeModal: null,
};




// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/PartsList/PartsListModal.js